// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__11mOw","productName":"Table_productName__3vZdK"};